import { z } from 'zod';
import { zInterventionProfile } from './intervention.js';

export const zStrategy = z.object({
  id: z.string(),
  name: z.string(),
  desc: z.string().default(''),
  tplKey: z.string().optional(),
  /** auto-composed by the optimizer (own entity) */
  isNoRegret: z.boolean().default(false),
  /** inferred from public data (competitors) — M2 makes this real */
  isMostLikely: z.boolean().default(false),
  interventions: z.array(zInterventionProfile),
});
export type Strategy = z.infer<typeof zStrategy>;

/** Starting-point templates (identical to the prototype's). */
export const STRAT_TEMPLATES: { key: string; name: string; desc: string; ivs: string[] }[] = [
  { key: 'growth', name: 'Aggressive Growth',        desc: 'Maximize expansion and market capture; bet on continued growth and abundant inputs.', ivs: ['expand_markets', 'scale_capex', 'new_geo', 'automation'] },
  { key: 'circ',   name: 'Efficiency & Circularity', desc: 'Cut throughput, close material loops, and decouple value creation from resource use.', ivs: ['circular', 'onsite_energy', 'automation', 'demand_shift'] },
  { key: 'hedge',  name: 'Resilience & Hedging',     desc: 'Build deep buffers, diversify dependencies, and prioritize downside protection.',      ivs: ['cash_buffer', 'hedge', 'local_sourcing', 'deleverage', 'reskill'] },
  { key: 'regen',  name: 'Regenerative Bet',         desc: 'Invest ahead of the transition: restoration, local supply, and long-horizon assets.',  ivs: ['regen_rnd', 'soil_restore', 'local_sourcing', 'onsite_energy'] },
];

/** Curated most-likely plays per entity type — the M1 placeholder for the
    M2 evidence-based inference (clearly labeled as such in the UI). */
export const MOSTLIKELY_BY_TYPE: Record<string, string[]> = {
  company:    ['expand_markets', 'scale_capex', 'automation', 'new_geo'],
  government: ['deleverage', 'local_sourcing', 'reskill', 'soil_restore'],
  ngo:        ['regen_rnd', 'soil_restore', 'local_sourcing'],
  individual: ['reskill', 'hedge', 'demand_shift'],
};
